<template>
  <div id="app" class="site container hfeed" style="height: auto !important">
    <HeadNav selectedLanguage="en" page="yo" />
    <div class="features-section features-bgList">
<div class="fm-header">
        <img class="fm-logo" src="@/assets/yo-logo.webp" alt="YO WhatsApp" />
        <div class="fm-header-right">
          <h1 class="intro-title header-title">YO WhatsApp APK Download Latest Version – Android 2026</h1>
          <div class="badge-list header-badges">
            <span>🛡️ Secured</span>
            <span>✔️ Certified</span>
            <span>✨ Top Rated</span>
          </div>
          <button class="free-download-btn header-download" @click="goDownload">Download YO WhatsApp</button>
        </div>
      </div>

      <p class="desc">
        YO WhatsApp is a popular WhatsApp MOD that offers enhanced customization, privacy options, and additional features not available
        in the official WhatsApp. Designed for Android devices, YO WhatsApp provides a smoother and more flexible messaging experience
        for users who want more control over how they chat, share media, and personalize the app.
      </p>

      <h2 class="intro-title">Features of YO WhatsApp</h2>
      <p class="desc">YO WhatsApp includes a range of unique features:</p>

      <h3 class="sub-title">Custom Themes and Appearance</h3>
      <p class="desc">
        YO WhatsApp allows users to change the app's look using thousands of themes. You can customize colors, chat bubbles, fonts,
        and icons to create a personalized experience that suits your style.
      </p>

      <h3 class="sub-title">Privacy Options</h3>
      <p class="desc">Privacy is enhanced with features such as:</p>
      <ul class="feature-list">
        <li><strong>Hide Last Seen</strong> – Control who can see your online activity.</li>
        <li><strong>Hide Blue Ticks and Second Tick</strong> – Read messages without letting others know.</li>
        <li><strong>Anti-Delete Messages</strong> – Prevent others from deleting messages in your chats.</li>
        <li><strong>Hide View Status</strong> – View friends' statuses without leaving a trace.</li>
      </ul>

      <h3 class="sub-title">Media Sharing</h3>
      <p class="desc">YO WhatsApp allows larger and multiple media sharing:</p>
      <ul class="feature-list">
        <li><strong>Send files up to 100MB</strong> without compression.</li>
        <li><strong>Share multiple images or videos</strong> at once using the multiple media selection feature.</li>
        <li><strong>Download statuses</strong> from friends' WhatsApp stories directly to your device.</li>
      </ul>

      <h3 class="sub-title">Messaging Enhancements</h3>
      <ul class="feature-list">
        <li><strong>Disappearing Messages</strong> – Send temporary messages that vanish after a set period.</li>
        <li><strong>Custom Stickers and Emojis</strong> – Use unique stickers to enhance conversations.</li>
        <li><strong>Schedule Messages</strong> – Plan messages to send at specific times automatically.</li>
      </ul>

      <h3 class="sub-title">Security Features</h3>
      <ul class="feature-list">
        <li><strong>Built-in App Lock</strong> – Protect your chats with PIN, pattern, or fingerprint authentication.</li>
        <li><strong>Dual WhatsApp Support</strong> – Run YO WhatsApp alongside the official WhatsApp on the same device.</li>
      </ul>

      <h2 class="intro-title">How to Download YO WhatsApp</h2>
      <ol class="download-steps">
        <li>Go to the YO WhatsApp download page on a trusted MOD APK site.</li>
        <li>Click the download button to get the latest APK.</li>
        <li>Enable <strong>Unknown Sources</strong> on your Android device (Settings → Security → Unknown Sources).</li>
        <li>Install the APK and verify your phone number.</li>
        <li>Restore backups if available.</li>
      </ol>
    

      <h2 class="intro-title">How to Use YO WhatsApp</h2>
      <ul class="feature-list">
        <li><strong>Messaging</strong> – Chat with friends and family as usual, with added privacy options.</li>
        <li><strong>Status Updates</strong> – View and post statuses, download others' stories if needed.</li>
        <li><strong>Media Sharing</strong> – Send high-quality videos, images, or documents easily.</li>
        <li><strong>Custom Themes</strong> – Apply or create themes for a unique look.</li>
      </ul>

      <h2 class="intro-title">Advantages of YO WhatsApp</h2>
      <ul class="feature-list">
        <li>Offers advanced customization and personalization.</li>
        <li>Provides privacy options that official WhatsApp lacks.</li>
        <li>Allows high-quality media sharing and downloads.</li>
        <li>Supports multiple accounts and dual apps.</li>
        <li>Adds additional messaging features such as scheduling and disappearing messages.</li>
      </ul>

      <h2 class="intro-title">FAQs About YO WhatsApp</h2>
      <div class="faq-list">
        <p><strong>Is YO WhatsApp safe?</strong><br />Use a trusted APK source. Avoid third-party sites with malware.</p>
        <p><strong>Can I use YO WhatsApp with official WhatsApp?</strong><br />Yes, both can run simultaneously with Dual WhatsApp support.</p>
        <p><strong>Does it require rooting?</strong><br />No, YO WhatsApp works without rooting your Android device.</p>
        <p><strong>Can I backup chats?</strong><br />Yes, you can backup and restore chats using Google Drive or local storage.</p>
      </div>

      <h2 class="intro-title">Conclusion</h2>
      <p class="desc">
        YO WhatsApp offers a superior messaging experience with extensive privacy, customization, and media sharing options. By combining
        features like <strong>Disappearing Messages</strong>,
        <a href="https://gbmodshub.com/built-in-app-lock-gbwhatsapp/">Built-in App Lock</a>, and
        <a href="https://gbmodshub.com/status-download-feature-gbwhatsapp/">Status Download</a>,
        YO WhatsApp stands out as one of the most versatile WhatsApp MODs for Android users.
      </p>

   
    </div>
  </div>
</template>

<script>
import '@/css/base.scss';
import '@/css/index.scss';
import HeadNav from '@/components/HeadNav.vue';

export default {
  name: 'YoWhatsappDownload',
  data() {
    return {
      pageName: 'yo-whatsapp',
      apk: null,
      from: 'yo',
      filename: 'yo',
    };
  },
  components: {
    HeadNav},
  mounted() {
    this.from = this.$global.GetQueryString('from') || this.from;
    this.filename = this.$global.GetQueryString('filename') || this.filename;
    if (this.$global.GetQueryString('from')) {
      this.getAPK();
    } else {
      this.getOfficalApk();
    }
  },
  methods: {
    getAPK() {
      this.$server
        .getAPPInfo({
          promotionChannel: this.from,
          promotionName: this.filename,
        })
        .then((res) => {
          if (res.code === 200) {
            this.apk = res.data.apk;
          } else {
            this.apk = process.env.VUE_APP_GBLINK;
          }
        });
    },
    getOfficalApk(type = 1, domain = null, appname = null) {
      this.$server
        .getOfficalApk({
          domain: domain || 'gbwhatsapp.chat',
          appName: appname || 'GB_gbwhatsapp.chat',
        })
        .then((res) => {
          if (res.code === 200) {
            if (type === 1) {
              this.apk = res.data.apk;
            }
          } else {
            this.apk = process.env.VUE_APP_GBLINK;
          }
        });
    },
    goDownload() {
      if (this.apk) {
        this.$global.download(this.apk);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.intro-title {
  font-weight: 700;
  font-size: 25px;
  padding: 10px 0;
  text-align: left;
}

.sub-title {
  font-weight: 700;
  font-size: 20px;
  padding: 8px 0 4px;
  text-align: left;
}

.badge-list {
  display: flex;
  padding-left: 18px;
  margin: 10px 0 20px;
  span {
    display: inline-block;
    margin-right: 15px;
    font-weight: 600;
    color: #1697BB;
  }
}

.free-download-btn {
  background-color: #1697BB;
  color: #fff;
  border: none;
  padding: 10px 20px;
  border-radius: 4px;
  cursor: pointer;
  font-size: 16px;
  margin: 10px 5px;
}

.desc {
  margin: 10px 0;
  line-height: 1.6;
  text-align: left;
}

.feature-list,
.download-steps {
  padding-left: 20px;
  margin: 10px 0;
  text-align: left;
}

.feature-list {
  list-style-type: disc;
}

.download-steps {
  list-style-type: decimal;
}

.feature-list li,
.download-steps li {
  text-align: left;
}

.faq-list p {
  margin: 10px 0;
  text-align: left;
}

.fm-header {
  display: flex;
  align-items: center;
  gap: 20px;
  margin-bottom: 20px;
  justify-content: center;
}

.fm-logo {
  width: 170px;
  height: 170px;
  object-fit: contain;
}

.fm-header-right {
  width: 700px;
}

.header-badges span {
  display: inline-flex;
  align-items: center;
  margin-right: 15px;
  font-weight: 600;
  color: #1697BB;
}

.header-download {
  margin-top: 10px;
  width: 100%;
}

.download-btn-wrapper {
  text-align: center;
  margin: 20px 0;
}

@media (max-width: 768px) {
  .fm-header {
    flex-direction: column;
    align-items: center;
  }
  .fm-logo {
    width: 60px;
    height: 60px;
  }
}
</style>
